import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8 23H16C18.2091 23 20 21.2091 20 19V8.5L12 1H8C5.79086 1 4 2.79086 4 5V19C4 21.2091 5.79086 23 8 23Z",
      class: "primary"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 1L15.8571 4.61607L20 8.5H14.4444C13.0944 8.5 12 7.40559 12 6.05556V1Z",
      class: "faded"
    }, null, -1)
  ])))
}
export default { render: render }